module.exports = __webpack_public_path__ + "images/emoji/tshirt.77a0455d981735f7a82b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tshirt.png
// module id = rulX
// module chunks = 13